<template>
  <div @click="click" :class="{ 'zul-button': true, 'disabled': disabled }" :disabled="disabled">
    <span v-if="$slots.icon" class="button-icon"><slot name="icon"></slot></span>
    <span class="button-label"><slot></slot></span>
    <span class="button-sub"><slot name="sub"></slot></span>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean
  },
  methods: {
    click () {
      if(!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';
  
  .zul-button {
    background-color: #000;
    background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMS4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDMxLjQ5IDMxLjQ5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAzMS40OSAzMS40OTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiPgo8cGF0aCBkPSJNMjEuMjA1LDUuMDA3Yy0wLjQyOS0wLjQ0NC0xLjE0My0wLjQ0NC0xLjU4NywwYy0wLjQyOSwwLjQyOS0wLjQyOSwxLjE0MywwLDEuNTcxbDguMDQ3LDguMDQ3SDEuMTExICBDMC40OTIsMTQuNjI2LDAsMTUuMTE4LDAsMTUuNzM3YzAsMC42MTksMC40OTIsMS4xMjcsMS4xMTEsMS4xMjdoMjYuNTU0bC04LjA0Nyw4LjAzMmMtMC40MjksMC40NDQtMC40MjksMS4xNTksMCwxLjU4NyAgYzAuNDQ0LDAuNDQ0LDEuMTU5LDAuNDQ0LDEuNTg3LDBsOS45NTItOS45NTJjMC40NDQtMC40MjksMC40NDQtMS4xNDMsMC0xLjU3MUwyMS4yMDUsNS4wMDd6IiBmaWxsPSIjZGVkZWRlIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=);

    background-repeat: no-repeat;
    background-position: 94% center;
    border-left: 2px transparent solid;
    transition: .2s all;



    @each $city, $map in $cities {
      .is-#{$city} & {
        border-left-color: map-get($map, 'primary');
      }            
    }

    &:not([disabled]):hover { background-position: 96% center; }

    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    padding: 5px;
    margin-bottom: 10px;

    cursor: pointer;

    strong {
      color: $white; // fix
    }

    &.disabled {
      opacity: .4;
      cursor: default;
    }

    .button-icon {
      padding: .2rem .7rem .35rem;
    }

    .button-label {
      margin-left: .3rem;
      line-height: 36px;
    }

    .button-sub {
      margin-left: auto;
      margin-right: 2.5rem;
      line-height: 36px;
      display: block;

      .is-masterpass {
        color: $primary;
        font-weight: bold;
        padding-right: .5rem;

        text-align: right;
        line-height: 22px;
      }
    }


    &.is-large {
      .button-icon {
        padding: .9rem;
      }

      .button-label {
        margin-left: .5rem;
        line-height: 67px;
      }

      .button-sub {
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
      }
    }
    
    &.is-view {
      border-left: none;
      background: $grey-dark;
      cursor: default;

      &.is-secondary {
        background: $grey;
      }

      .button-sub {
        margin-right: .7rem;
      }
    }
  }

  .label {
    color: #fff;
    margin-bottom: 0 !important;
  }
</style>
